import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { USER_DETAIL_QUERY_KEYS } from '../queryKeys';
import { QueryOptions } from '../../../../../../types/query/useQuery';
import { AccountUserApiV2 } from '../../../../../../lib/api/account/user/AccountUserApiV2';
import { AccountUserDetailTypeV2 } from '../types/accountUserDetail';

type UseAccountUserDetailQueryParamsType<SelectResultType> = {
  userId?: number;
  options: QueryOptions<{ user: AccountUserDetailTypeV2 }, Error, SelectResultType>;
};
export const useAccountUserDetailQueryV2 = <SelectResultType>(
  props: UseAccountUserDetailQueryParamsType<SelectResultType>,
): UseQueryResult<SelectResultType> => {
  const { userId, options } = props;
  return useQuery<{ user: AccountUserDetailTypeV2 }, Error, SelectResultType>(
    [...USER_DETAIL_QUERY_KEYS.USER_INFO_V2, userId],
    () => AccountUserApiV2.getAccountUserDetail(userId as number),
    {
      ...options,
    },
  );
};
